<template>
  <div id="file-outgoing-container">
    <!-- 上传标题 -->
    <mtd-row>
      <mtd-col :span="24">
        <span class="dd-page-title">{{ $getText('wenshu_web_file_upload', '文件上传') }}</span>
      </mtd-col>
    </mtd-row>
    <!-- 文件上传框 -->
    <div style="margin-top: 12px;">
      <mtd-upload class="drag-upload" ref="upload" drag multiple :limit="max_limit" :show-file-list="false"
                  :before-upload="before_file_upload" :on-progress="file_on_progress" :on-success="handleUploadSuccess"
                  :on-error="handleUploadError" action="/api/wenshu/file_data_collect/upload_file"
                  :file-list="file_list" :on-exceed="show_limit_message">
        <div :class="{'upload-hot-area':drag}"
             style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center">
          <div class="upload-content">
            <div class="mtd-upload-text">
              <div class="title-text">
                <span>{{ $getText('wenshu_web_drag_file_here_to_upload_or', '将文件拖至此处上传，或') }}
                  <span style="color: #0A70F5;text-decoration: underline;">{{ $getText('wenshu_web_click_to_upload', '点击上传') }}</span>
                </span>
              </div>
              <div class="tips"><span>{{ $getText('wenshu_web_folder_not_supported_max_files_upload_limit_upload_file_size_limit_100m', {max: this.max_limit}, '不支持文件夹，最多同时上传{max}个，上传文件必须≤100M') }}</span></div>
            </div>
          </div>
        </div>
      </mtd-upload>
    </div>
    <!-- 文件列表显示 -->
    <mtd-row style="margin-top: 4px" :gutter="8" v-if="file_list.length !== 0">
      <mtd-col :span="12" style="margin-top: 8px;" v-for="(item, index) in file_list" class="file-container-block"
               v-bind:class="{ 'padding-left-0': index%4===0, 'padding-right-0': index%4===3 }">
        <div class="file-item-block">
          <div class="file-type-icon"><img :src="require('@/assets/'+pictureSelect(item)+'.png')"></div>
          <div class="progress-status-container">
            <div class="file-name-div">{{ item.fileName }}</div>
            <div class="progress-div" :class="[upload_status_class(item)]">
              <mtd-icon name='bolt-fill'></mtd-icon>
              <mtd-progress :percentage="item.percentage" :stroke-width="4" class="file-upload-progress"/>
              <div class="file-upload-show-text">
                <span>{{ item.message }}</span>
              </div>
            </div>
          </div>
          <div class="delete-file-container">
            <mtd-icon-button type="secondary" icon="mtdicon mtdicon-close" @click="remove_exist_file(item)"
                             v-if="item.fileStatus === 'exist'"/>
            <mtd-icon-button class="icon-btn" icon="mtdicon mtdicon-refresh-o" @click="re_upload(item)"
                             v-if="item.fileStatus === 'fail'"/>
          </div>
        </div>
      </mtd-col>
    </mtd-row>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "file_out_upload",
    data() {
      return {
        file_list: [],
        max_limit: 5,
        drag: false,
      }
    },
    mounted() {
      // 添加默认事件
      const upload_dragger = document.querySelector('.mtd-upload-dragger');
      upload_dragger.addEventListener('dragover', function () {
        this.className += 'mtd-upload-dragger drag-over';
      });
      upload_dragger.addEventListener('dragstart', function () {
        this.className = 'mtd-upload-dragger';
      });
    },
    computed: {},
    methods: {
      before_file_upload(data) {
        let file = {
          fileName: data.name,
          type: data.type,
          percentage: 0,
          fileSize: data.size,
          uid: data.uid,
          message: this.$getText('wenshu_web_uploading', '上传中...')
        };
        this.file_list.unshift(file);
        return true;
      },
      file_on_progress(event, file) {
        let index = this.file_list.findIndex(item => item.uid === file.uid);
        this.file_list[index].percentage = event.percent;
      },
      handleUploadSuccess(response, file) {
        let index = this.file_list.findIndex(item => item.uid === file.uid);
        if (response.code === 0) {
          const message = response.message;
          if (message === '文件已存在') {
            this.file_list[index].fileStatus = 'exist';
            this.file_list[index].message = this.$getText('wenshu_web_file_already_exists', '文件已存在');
            this.handleUploadError(this.$getText('wenshu_web_file_already_exists', '文件已存在'));
          } else {
            this.file_list[index].fileStatus = 'success';
            this.file_list[index].message = this.$getText('wenshu_web_upload_successful', '上传成功');
          }
        } else {
          this.file_list[index].fileStatus = 'fail';
          this.file_list[index].message = this.$getText('wenshu_web_upload_failed', '上传失败');
          this.handleUploadError(response.message);
        }
      },
      handleUploadError(err) {
        if (err.type === 'error') {
          this.$mtd.message.error(this.$getText('wenshu_web_network_error', '网络错误'));
        } else {
          this.$mtd.message.error(this.$getText('wenshu_web_request_error', '请求出错') + err);
        }
      },
      show_limit_message() {
        this.$mtd.message.error(this.$getText('wenshu_web_max_upload_files', '最多同时上传5个文件'));
      },
      re_upload(file) {
        let index = this.file_list.indexOf(file);
        this.file_list[index].fileStatus = "ready";
        this.$refs.upload.submit();
      },
      pictureSelect(file) {
        let fileName = file.fileName;
        if (!fileName || fileName === '') {
          return 'usual';
        }
        let temp = fileName.split('.');
        if (!temp || temp.length === 0) {
          return 'usual';
        }
        let fileType = temp[temp.length - 1].toLowerCase();
        switch (fileType) {
          // 表格
          case 'xlsx':
          case 'xls':
            return 'excel';
          // word
          case 'doc':
          case 'docx':
            return 'word';
          // 压缩包
          case 'zip':
            return 'zip';
          // ppt
          case 'ppt':
          case 'pptx':
            return 'ppt';
          // pdf
          case 'pdf':
            return 'pdf';
          // 视频
          case 'avi':
          case 'mpg':
          case 'wmv':
          case 'mov':
          case 'mp4':
            return 'video';
          // 音频
          case 'mp3':
          case 'wma':
            return 'music';
          // 图片
          case 'png':
          case 'gif':
          case 'jpg':
          case 'jpeg':
            return 'picture';
          // 图片素材
          case 'psd':
            return 'PS';
          // 图片素材
          case 'sketch':
            return 'sketch';
          // numbers
          case 'numbers':
            return 'numbers';
          // keynote
          case 'keynote':
            return 'keynote';
          // ai
          case 'ai':
            return 'AI';
          default:
            return 'usual'
        }
      },
      upload_status_class(item) {
        if (item.fileStatus === 'success') {
          return 'upload-result-success'
        } else if (item.fileStatus === 'fail') {
          return 'upload-result-fail'
        } else if (item.fileStatus === 'exist') {
          return 'upload-result-fail'
        } else {
          return 'upload-result-default'
        }
      },
      remove_exist_file(file) {
        let index = this.file_list.indexOf(file);
        this.file_list.splice(index, 1);
      }
    }
  }
</script>

<style>

  #file-outgoing-container {
    margin-bottom: 80px;
  }

  .padding-left-0 {
    padding-left: 0 !important;
  }

  .padding-right-0 {
    padding-right: 0 !important;
  }

  .margin-bottom-0 {
    margin-bottom: 0;
  }

  .dd-page-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 32px;
    font-weight: 500;
  }

  .dd-page-subtitle {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 22px;
    font-weight: 500;
  }

  .page-info-detail {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.36);
    line-height: 20px;
    font-weight: 400;
    margin-left: 10px;
  }

  h2.file-list-title {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .mtd-progress .mtd-progress-percentage {
    display: none;
  }

  .mtd-progress .mtd-progress-bar {
    padding-right: 0;
    margin-right: 0;
    margin-bottom: 3px;
  }

  .icon-btn {
    font-size: 16px;
    margin-right: 8px;
    float: right;
    padding: 0;
  }

  .icon-file-name {
    width: 100%;
    height: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 22px;
    position: absolute;
    top: 12px;
    flex-direction: row;
  }

  .mtd-icon-btn {
    width: 22px;
    height: 22px;
  }

  .margin-top-20 {
    height: 100%;
    top: -50px;
  }

  .full-height-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-success {
    border-color: #00B365;
  }

  .result-fail {
    border-color: #F5483B;
  }

  .mtd-upload-dragger {
    height: 136px;
  }

  .mtd-upload-dragger.drag-over {
    background: rgba(239, 248, 255, 0.50);
    border: 1px dashed #0A70F5;
    border-radius: 4px;
  }

  .mtd-upload-dragger, .drag-upload, .mtd-upload {
    text-align: center;
    width: 100%;
  }

  .upload-content {
    height: 136px;
  }

  .file-container-block {
    min-width: 160px;
  }

  .upload-content .mtd-upload-text .title-text {
    margin-top: 32px;
    margin-bottom: 16px;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.60);
    line-height: 22px;
    font-weight: 400;
  }

  .upload-content .mtd-upload-text .tips {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.36);
    text-align: center;
    line-height: 17px;
    font-weight: 400;
  }

  .mtd-upload-dragger {
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .mtd-message {
    min-width: 20px;
    padding: 6px 16px;
  }

  .el-input__inner {
    border-radius: 4px;
  }


  .file-extra {
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .file-extra-content {
    padding: 12px 16px;
  }

  .mtd-collapse-item-header {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .mtd-collapse-item-content {
    padding: 0;
  }

  .file-item-block {
    height: 44px;
    opacity: 0.8;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 2px;
  }

  .file-type-icon {
    width: 26px;
    height: 42px;
    text-align: center;
    vertical-align: middle;
    padding-top: 10px;
    float: left;
  }

  .file-type-icon img {
    height: 22px;
  }

  .progress-status-container {
    width: calc(100% - 56px);
    height: 42px;
    float: left;
    padding: 5px 0;
  }

  .progress-status-container .file-name-div {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 14px;
    font-weight: 500;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 16px;
  }

  .progress-status-container .progress-div {
    margin-top: 4px;
    height: 14px;
  }

  .upload-result-default {
    color: #0A70F5;
  }

  .upload-result-success,
  .upload-result-success .file-upload-progress,
  .upload-result-success .file-upload-show-text {
    color: #00B365 !important;
    opacity: 1 !important;
  }

  .upload-result-fail,
  .upload-result-fail .file-upload-progress,
  .upload-result-fail .file-upload-show-text {
    color: #DD3429 !important;
    opacity: 1 !important;
  }

  .progress-status-container .progress-div .mtdicon-bolt-fill {
    float: left;
  }

  .progress-status-container .progress-div .file-upload-progress {
    width: calc(100% - 120px);
    display: inline-block;
    float: left;
    border: none;
  }

  .progress-status-container .progress-div .file-upload-show-text {
    opacity: 0.5;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.84);
    font-weight: 500;
    line-height: 14px;
    display: inline-block;
    margin-left: 4px;
    float: left;
  }

  .delete-file-container {
    width: 30px;
    height: 42px;
    float: right;
    padding: 11px 5px;
  }

  .delete-file-container .mtd-icon-btn {
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .submit-buttons-div {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 64px;
    padding: 12px 0;
    text-align: center;
    border-top: 1px #E0E0E0 solid;
    left: 0;
    background-color: #fff;
    z-index: 999;
  }

</style>
